import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/brand",
    name: "brand",
    component: dashboard,
    redirect: {
      name: "brandIndex"
    },
    children: [
      {
        path: "brandIndex",
        name: "brandIndex",
        meta: { title: "品牌着陆页设置" },
        component: () => import("@/views/brand/baseDataBrand.vue"),
        children: [
          {
            path: "editBrandInfo/:brandId",
            name: "editBrandInfo",
            meta: { title: "编辑品牌着陆页" },
            component: () => import("@/views/brand/brandManage.vue")
          },
          {
            path: "addBrandInfo",
            name: "addBrandInfo",
            meta: { title: "添加品牌着陆页" },
            component: () => import("@/views/brand/addBrand.vue")
          }
        ]
      }
    ]
  }
];
